






















































































































































































































import { Type } from 'expangine-runtime';
import { ListOptions } from '../../common';
import { TypeModifyOption, TypeModifyHandler } from './TypeModifier';
import TypeEditorBase from './TypeEditorBase';


export default TypeEditorBase<Type, any, any>().extend({
  props: {
    icon: {
      type: String,
      default: 'mdi-settings',
    },
  },
  data: () => ({
    editing: false,
    configuring: false,
    inputing: false,
    previewing: null,
  }),
  computed: {
    modifiableOptions(): ListOptions<TypeModifyHandler> {
      return this.registry.getTypeModifiersFor({
        registry: this.registry,
        parent: this.parent,
        type: this.type,
        typeSettings: this.settings,
        noTransform: this.noTransform,
      });
    },
    previewValue: {
      get(): any {
        return this.previewing || this.type.fromJson(this.settings.defaultValue);
      },
      set(value: any) {
        this.previewing = value;
      },
    },
    requiredTypeString(): string {
      return this.requiredType
        ? this.registry.getTypeDescribeLong(this.requiredType, '  ', '\n')
        : '';
    },
  },
  methods: {
    async onModify(modifier: TypeModifyOption) {
      this.editing = false;
      
      const result = await modifier.value();

      if (result) {
        this.triggerChange(result);
      }

      this.done();
    },
    done() {
      this.configuring = false;
      this.inputing = false;
      this.editing = false;
    },
  },
});
